import React from 'react'
import Link from 'gatsby-link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDotCircle } from '@fortawesome/free-solid-svg-icons'
import BourbonParty2 from '../assets/images/BB_Bourbon-70.jpg'


const PriceBox = () => (
    <section className="price-box-section">
        <div className="columns is-centered price-box-highlight">
            <div className="column is-two-thirds">
                <div className="title has-text-centered">Are you setting the tone, telling a story, or immersing your guests? We've got you covered.</div>
            </div>
        </div>
        <div className="columns">
            <div className="column">
                <div className="content m-l-lg m-t-lg">
                    <div className="is-size-3 ">You're in the drivers seat.</div>
                    <div className="is-size-4 has-text-primary">Pick the bundle that fits your vision.</div>
                    <div id="bundle-content">
                        <ul>
                            <li><FontAwesomeIcon icon={faDotCircle} size="1x" className="bullets" /><span className="box-items">Every item is high quality and reusable.</span></li>
                            <li><FontAwesomeIcon icon={faDotCircle} size="1x" className="bullets" /><span className="box-items">Tips to help you take it to the next level.</span></li>
                            <li><FontAwesomeIcon icon={faDotCircle} size="1x" className="bullets" /><span className="box-items"></span>No hassle returns.</li>
                            <li><FontAwesomeIcon icon={faDotCircle} size="1x" className="bullets" /><span className="box-items"></span>No subscriptions.</li>
                            <li><FontAwesomeIcon icon={faDotCircle} size="1x" className="bullets" /><span className="box-items"></span>Free Shipping.</li>
                        </ul>
                    </div>
                    <div className="is-size-4 m-t-lg">Nothing tacky.</div>
                    <div className="is-size-5">Just great items to fill your memories and party tool kit.</div>           
                </div>
            </div>
            <div className="column "><img src={BourbonParty2} /></div>
        </div>

        <div className="columns is-centered price-box-highlight">
            <div className="column is-half">
                <div className="title has-text-centered">Dreams, meet real life.</div>
                <div className="has-text-centered is-size-5">
                    Real life should be better than your news feed. The difference between real life and Instagram is a little creative direction.
                </div>
                <div className="m-t-md has-text-centered is-size-5">
                    So we design bundles that invite your guests into a story they'll want to talk about. Then we give you the tools to pull it off like a Pinterest Pro.
                </div>
            </div>
        </div>
    </section>
)

export default PriceBox


// WEBPACK FOOTER //
// ./src/components/priceBox.js